import { __assign } from "tslib";
import { connectMediaStore, useMMSelector, useMMDispatchActions, } from './withOwnReduxStore';
import { setCurrentSubfolderId, unsetCurrentSubfolderId } from '../actions';
import { getCurrentSubfolderId, getCurrentSubfolder } from '../selectors';
export var useCurrentSubfolder = function () { return (__assign(__assign({}, useMMSelector(function (state) { return ({
    currentSubfolderId: getCurrentSubfolderId(state),
    currentSubfolder: getCurrentSubfolder(state),
}); })), useMMDispatchActions({ setCurrentSubfolderId: setCurrentSubfolderId, unsetCurrentSubfolderId: unsetCurrentSubfolderId }))); };
export default connectMediaStore(function (state) { return ({
    currentSubfolderId: getCurrentSubfolderId(state),
    currentSubfolder: getCurrentSubfolder(state),
}); }, {
    setCurrentSubfolderId: setCurrentSubfolderId,
    unsetCurrentSubfolderId: unsetCurrentSubfolderId,
});
//# sourceMappingURL=withCurrentSubfolder.js.map